import React from "react";
import AdminSectionShell from "../components/AdminSectionShell";
import ViewDashboardOperacionalIrregularidades from "../views/ViewDashboardOperacionalIrregularidades";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const DashboardOperacionalIrregularidades: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");

  if (isLoading) {
    return <p>Verificando permissao...</p>;
  }

  if (!isValid) {
    return null;
  }

  return (
    <AdminSectionShell backTo="/dashboardOperacional">
      <ViewDashboardOperacionalIrregularidades />
    </AdminSectionShell>
  );
};

export default DashboardOperacionalIrregularidades;
